


































































































































































































































































































































































































































































import ConfirmationDialog from './ConfirmationDialog.vue';
import ConfirmationModifyDialog from './ConfirmationModifyDialog.vue';
import CanvasModify from './CanvasModify.vue';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import {
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
    // AuthStoreHelper,
    // NotificationStoreHelper
} from '../../core/mixins';
import { Component, Prop, Watch, Vue, Emit, Mixins } from 'vue-property-decorator';
import LabelWithValue from '../../core/components/LabelWithValue.vue';
import Button from '../../core/components/Button.vue';
import { MultipleSelect } from '../../core/components';
import multiselect from 'vue-multiselect';
import { JourneysService } from '../api/JourneysService';
import { SettingsService } from '../../settings/api/SettingsService';
import { Mounted } from '../../core/decorators';
import ConfirmAction from './ConfirmAction.vue';
import { dateIsSameOrAfterSecond, existItemInList, getDateAsMoment, getDateFormattedAsMoment, getDiffToNow, getDurationBetweenDates, getIndexFromList, ID, isNullOrEmpty, sortObjectByPropertyName, timeIsValid } from '../../core/utils';
import { dateTypes, diffOptions } from '../../core/models';
import { info } from 'console';

@Component({
    components: {
        MultipleSelect,
        multiselect,
        ConfirmAction,
        Loading,
        LabelWithValue,
        Button
    }
})
export default class FormAbm extends Mixins(
    NotificationStoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    CompanyStoreHelper,
    StoreHelper
) {
    @Prop({default: -1}) journeyCalcType: ID;
    @Prop({default() {return []}}) journeysCalcTypes: Array<object>;
    @Prop() formDataProp: any;
    @Prop() formAction: string | null;
    @Prop({default() {return []}}) hourTypes: Array<object>;
    pendingRequest: boolean = false;
    hasSavedAuxFormData: boolean = false;
    auxFormData: any = null;
    formDriver: any = null;
    preselectOptions: any = [];
    valid: boolean = false;
    menuStart: boolean = false;
    menuEnd: boolean = false;
    setMinDate: any = this.getTodayDateLessVal(100);
    setMaxDate: any = this.getTodayDateLessVal(16);
    dateIsValid: boolean = false;
    hoursAreValid: boolean = false;
    periodsAreValid: boolean = false;
    periodErrorMsg: string = '';
    defaultFormData: any = {
        driver: '',
        vehicle: null,
        dateStart: null,
        dateEnd: null,
        hourEnd: null,
        simpleHours: {
            hours: null,
            minutes: null
        },
        nightHours: {
            hours: null,
            minutes: null
        },
        extraHours: {
            hours: null,
            minutes: null
        },
        simplePresentHours: {
            hours: null,
            minutes: null
        },
        overnightHours: {
            hours: null,
            minutes: null
        },
        simpleSpecialHours: {
            hours: null,
            minutes: null
        },
        extraSpecialHours: {
            hours: null,
            minutes: null
        },
        stoppedTimeHours: {
            hours: null,
            minutes: null
        },
        extraRestHours: {
            hours: null,
            minutes: null
        },
        simpleRestHours: {
            hours: null,
            minutes: null
        },
        closed_segments: [],
        summary: {},
    };
    formData: any = this.defaultFormData;
    hoursList: any = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48'
    ];
    hoursSelector: any = [];
    hoursValidation: any = [(v) => !!v || 'Seleccione'];
    totalJourneyHours: number = 0;
    totalTimeAssigned: number = 0;
    totalTimeAssignedFormatted: any = 0;
    totalJourneyTime: any = 0;
    formIsValid: boolean = false;
    processingRequest: boolean = false;
    assignedHoursAreValid: boolean = false;
    maxDate: string = new Date().toISOString().substr(0, 10);
    driverName: string = '';
    journeyHours: number = 0;
    journeyMinutes: number = 0;
    totalHoursAssigned: number = 0;
    totalMinutesAssigned: number = 0;
    unnasignedHours: number = 0;
    errors: any = [];
    headersPeriod: any = [
        {
            text: 'Vehiculo',
            value: 'vehicle',
            sortable: false
        },
        {
            text: 'Inicio',
            value: 'datetime_from',
            sortable: true
        },
        {
            text: 'Fin',
            value: 'datetime_to',
            sortable: true
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: false,
            width: '100px'
        }
    ];
    precalculated: boolean = false;
    checkPeriodsChange: boolean = false;
    stops: any[] = [];
    periodItems: any[] = [];
    periodsWhenPrecalculate: any[] = [];
    editedIndex: number = -1;
    editedItem: any = {
        id: 0,
        vehicle: '',
        datetime_from: '',
        datetime_to: '',
        hourStart: '00:00',
        hourEnd: '23:59',
        saved: false
    };
    defaultItem: any = {
        id: 0,
        vehicle: '',
        edit: false,
        datetime_from: '',
        datetime_to: '',
        hourStart: '00:00',
        hourEnd: '23:59',
        saved: false,
    };
    visibleConfirmAction: boolean = false;
    selectedItemForDeletion: any = null;

    errorEndDate: boolean = false;
    rangeSelectedIsValid: boolean = false;
    errorHourEndDate: boolean = false;
    noHoursTypeMessage: string = "La Empresa seleccionada no tiene asociados tipos de horas.";

    sortBy: string[] = ["datetime_to", "datetime_from"];
    sortDesc: boolean[] = [false, false];

    @Mounted
    ready() {
        this.handleListenKey(true);
        if(this.formAction == 'edit'){
            this.observableAssignedMinutes(null);
            this.loadFormData();
        }
        
    }

    created(){
         
    }

    mounted(){
        this.cancel();
    }


    editItem(item, edit = true) {
        this.editedIndex = this.periodItems.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editedItem.edit = edit;
    }

    deleteItem(item) {
        const index = this.periodItems.indexOf(item);
        this.periodItems.splice(index, 1);
        this.closeDeleteConfirmation();
    }

    closeDeleteConfirmation() {
        this.visibleConfirmAction = false;
    }

    openDeleteConfirmation(item = null) {
        this.selectedItemForDeletion = item;
        this.visibleConfirmAction = true;
    }

    close() {
        this.deleteItem(this.editedItem);
        this.setDefaultEditItem();
    }

    setDefaultEditItem(){
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
    }

    cancel() {
        // setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        // }, 300)
    }

    addNew() {
        const addObj = Object.assign({}, this.defaultItem);
        // Guarda las ids que hay dentro de periodItems en un array de numeros
        const arrOfIdsOfPeriodItems = this.periodItems.map(period => period.id)
        // Obtiene el valor mas grande de ese array de numeros
        const bigestId = this.maxValueInArr(arrOfIdsOfPeriodItems)
        // Le suma 1 al numero mas grande obtenido en el array de numeros
        addObj.id = bigestId + 1;
        this.periodItems.push(addObj);
        this.editItem(addObj, false);
    }

    maxValueInArr(arr){
        let max = 0;
        for ( let numero of arr ) {
        if (max < numero)
            max = numero;
        }
        return max
    }
    
    save() {
        this.clearErrors();
        if (this.editedIndex > -1) {
            let previousPeriods = this.periodItems;
            this.periodItems = [];
            this.periodItems = previousPeriods;
            const period = this.periodItems[this.editedIndex];
            const valid = this.validateDateTime(this.editedItem);
            if (!valid) return;
            this.editedItem.saved = true;
            Object.assign(period, this.editedItem);
            period.edit = false;
        }
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
    }

    getDateWithoutHours(date: Date): Date {
        const cloneDate = new Date(date);
        cloneDate.setHours(0);
        cloneDate.setMinutes(0);
        cloneDate.setSeconds(0);
        return cloneDate;
    }

    clearErrors() {
        this.errorEndDate = false;
        this.errorHourEndDate = false;
    }

    dateRangesOverlap(dateRangeA, dateRangeB) {
        return dateRangeA.datetime_from <= dateRangeB.datetime_to && dateRangeA.datetime_to >= dateRangeB.datetime_from;
    }

    getDateRange(period) {
        const periodEndDate: Date = this.getPeriodEndDate(period);
        const periodStartDate: Date = this.getPeriodStartDate(period);
        return { datetime_from: periodStartDate, datetime_to: periodEndDate };
    }

    validatePeriodStartAndEndDate(period): boolean {
        const periodEndDate: Date =  this.getPeriodEndDate(period);
        const periodStartDate: Date = this.getPeriodStartDate(period);
        if (periodStartDate < periodEndDate) {
            this.rangeSelectedIsValid = true;
            this.errorEndDate = false;
            this.errorHourEndDate = false;
            return true;
        }

        this.rangeSelectedIsValid = false;

        const startDayWithoutHours = this.getDateWithoutHours(periodStartDate);
        const endDayWithoutHours = this.getDateWithoutHours(periodEndDate);

        if (startDayWithoutHours > endDayWithoutHours) {
            this.errorEndDate = true;
            this.$_showHistoricalError('La fecha de fin debe ser posterior o igual a la inicial');
        } else {
            this.$_showHistoricalError('La hora de fin debe ser posterior a la inicial');
            this.errorHourEndDate = true;
        }
        return false;
    }

    validatePeriodOverlap(period): boolean {
        const rangeOfThePeriodToInsert = this.getDateRange(period);
        const periodsWithoutCurrentInsertPeriod = this.periodItems.filter((range) => range.id != period.id);

        let overlap = false;
        for (let otherPeriod of periodsWithoutCurrentInsertPeriod) {
            if (overlap) break;
            let rangePeriodOfTheTable = this.getDateRange(otherPeriod);
            overlap = this.dateRangesOverlap(rangePeriodOfTheTable, rangeOfThePeriodToInsert);
        }

        if (overlap) {
            this.$_showHistoricalError('Los períodos no pueden sobreponerse');
            return false;
        }
        return true;
    }

    validateDateTime(period): boolean {
        return this.validatePeriodOverlap(period) && this.validatePeriodStartAndEndDate(period);
    }

    get getParsedHourTypes(){
        let self = this;
        return this.hourTypes.map(function(hourType){
            return {
                ...hourType,
                model: self.getFormDataHourModel(hourType['type'])
            }
        });

    }


    getFormDataHourModel(type){
        switch(type){
            case 'night':
                return this.formData.nightHours
            case 'simples':
                  return this.formData.simpleHours
            case 'extra':
                return this.formData.extraHours
            case 'simple_presence_time':
                return this.formData.simplePresentHours
            case 'overnight':
                return this.formData.overnightHours
            case 'simple_special':
                return this.formData.simpleSpecialHours
            case 'simple_rest':
                return this.formData.simpleRestHours
            case 'extra_rest':
                return this.formData.extraRestHours
            case 'extra_special':
                return this.formData.extraSpecialHours
            case 'vehicle_stopped_time':
                return this.formData.stoppedTimeHours
        }
    }
    
    @Watch('$route', { immediate: true, deep: true })
    @Watch('$_getVehiclesFromSelectedCompanySorted')
    setData(){
        if(!this.formDataProp.hourStart) return
        this.setFormData(this.formDataProp)
    }


    setFormData(data) {
        this.$set(this.formData, 'driver', data.driver);
        this.$set(this.formData, 'vehicle', data.vehicle);
        this.$set(this.formData, 'dateStart', data.dateStart);
        this.$set(this.formData, 'dateEnd', data.dateEnd);
        this.$set(this.formData.simpleHours, 'hours', data.simpleHours.hours);
        this.$set(this.formData.simpleHours, 'minutes', data.simpleHours.minutes);
        this.$set(this.formData.nightHours, 'hours', data.nightHours.hours);
        this.$set(this.formData.nightHours, 'minutes', data.nightHours.minutes);
        this.$set(this.formData.extraHours, 'hours', data.extraHours.hours);
        this.$set(this.formData.extraHours, 'minutes', data.extraHours.minutes);
        this.$set(this.formData.simplePresentHours, 'hours', data.simplePresentHours.hours);
        this.$set(this.formData.simplePresentHours, 'minutes', data.simplePresentHours.minutes);
        this.$set(this.formData.overnightHours, 'hours', data.overnightHours.hours);
        this.$set(this.formData.overnightHours, 'minutes', data.overnightHours.minutes);
        this.$set(this.formData.simpleSpecialHours, 'hours', data.simpleSpecialHours.hours);
        this.$set(this.formData.simpleSpecialHours, 'minutes', data.simpleSpecialHours.minutes);
        this.$set(this.formData.stoppedTimeHours, 'hours', data.stoppedTimeHours.hours);
        this.$set(this.formData.stoppedTimeHours, 'minutes', data.stoppedTimeHours.minutes);
        this.$set(this.formData.extraSpecialHours, 'hours', data.extraSpecialHours.hours);
        this.$set(this.formData.extraSpecialHours, 'minutes', data.extraSpecialHours.minutes);
        this.$set(this.formData.extraRestHours, 'hours', data.extraRestHours.hours);
        this.$set(this.formData.extraRestHours, 'minutes', data.extraRestHours.minutes);
        this.$set(this.formData.simpleRestHours, 'hours', data.simpleRestHours.hours);
        this.$set(this.formData.simpleRestHours, 'minutes', data.simpleRestHours.minutes);
        this.periodItems = this.getCloseSegments(data);
    }

    loadFormData() {
        if(this.formAction == 'edit'){
            if(!this.hasSavedAuxFormData) {
                this.auxFormData = JSON.parse(JSON.stringify(this.formDataProp))
                this.hasSavedAuxFormData = true;
            }
            let secondAuxFormData = JSON.parse(JSON.stringify(this.auxFormData))
            this.setFormData(secondAuxFormData);
            
        }
    }
    

    getCloseSegments(data){
            // VEHICULOS CON TODOS LOS DATOS SEGUN LAS IDS QUE SE TRAEN EN FORMDATAPROP Y AUXFORMDATA
            let formDataFromBackend = data;
            if(!formDataFromBackend.closed_segments[0].hourEnd){
                let vehicles = formDataFromBackend.closed_segments.map(v => { return formDataFromBackend.summary.vehicles.filter(vehicle => {return vehicle.id==v.vehicle_id}) }).map(vehicle => vehicle[0])
                for (let i = 0; i < formDataFromBackend.closed_segments.length; i++) { formDataFromBackend.closed_segments[i].id = i+1 }

                formDataFromBackend.closed_segments = this.getParsedClosedSegments(formDataFromBackend.closed_segments, vehicles)

                formDataFromBackend.closed_segments.map(segment => segment.saved=true)
                formDataFromBackend.closed_segments.map(segment => segment.edit=false)

                formDataFromBackend.closed_segments.map(segment => { segment.hourStart = this.getOnlyHourAndMinutes(new Date(segment.datetime_from)) })
                formDataFromBackend.closed_segments.map(segment => { segment.hourEnd = this.getOnlyHourAndMinutes(new Date(segment.datetime_to)) })

                formDataFromBackend.closed_segments.map(segment => { segment.datetime_from = this.getOnlyDateDay(new Date(segment.datetime_from)) })
                formDataFromBackend.closed_segments.map(segment => { segment.datetime_to = this.getOnlyDateDay(new Date(segment.datetime_to)) })
            }
            return formDataFromBackend.closed_segments
    }

    getVehicleFromVehicleId(vehicles, vehicle_id){
        return vehicles.find(vehicle => vehicle.id == vehicle_id)
    }

    getParsedSegment(vehicles, closed_segment) {
        const vehicle = this.getVehicleFromVehicleId(vehicles, closed_segment.vehicle_id);
        return { ...closed_segment, vehicle: vehicle };
    }

    getParsedClosedSegments(segments, vehicles) {
        return segments.map((segment) => this.getParsedSegment(vehicles, segment));
    }

    @Prop()
    showVuetifyTable: boolean = false;

    @Watch('showVuetifyTable')
    observableField(){
        this.cancel();
    }


    @Watch('formData.simpleHours.hours')
    @Watch('formData.nightHours.hours')
    @Watch('formData.extraHours.hours')
    @Watch('formData.simplePresentHours.hours')
    @Watch('formData.overnightHours.hours')
    @Watch('formData.simpleHours.minutes')
    @Watch('formData.nightHours.minutes')
    @Watch('formData.extraHours.minutes')
    @Watch('formData.simplePresentHours.minutes')
    @Watch('formData.overnightHours.minutes')
    @Watch('formData.simpleSpecialHours.hours')
    @Watch('formData.simpleSpecialHours.minutes')
    @Watch('formData.extraSpecialHours.hours')
    @Watch('formData.extraSpecialHours.minutes')
    @Watch('formData.stoppedTimeHours.hours')
    @Watch('formData.stoppedTimeHours.minutes')
    @Watch('formData.extraRestHours.hours')
    @Watch('formData.extraRestHours.minutes')
    @Watch('formData.simpleRestHours.hours')
    @Watch('formData.simpleRestHours.minutes')
    observableAssignedMinutes(value) {
        this.calculateAssignedTime();
    }

    calculateAssignedTime() {
        let initTimeAssigned = this.getTotalHoursAssigned() + ':' + this.getTotalMinutesAssigned();
        let timeAssigned = this.formatAssignedTime(initTimeAssigned);
        this.totalHoursAssigned = parseInt(timeAssigned.split(':')[0]);
        this.totalMinutesAssigned = parseInt(timeAssigned.split(':')[1]);
    }

    getFormattedData() {
        let data = {
            company_id: this.$_getSelectedCompanyById as number,
            driver_id: this.formData.driver.ci,
            datetime_from: this.getTransformedDateTime(this.getJourneyStartDate), //this.getDateTime(this.formData['dateStart'], this.formData['hourStart']),
            datetime_to: this.getTransformedDateTime(this.getJourneyEndDate), //this.getDateTime(this.formData['dateEnd'], this.formData['hourEnd']),
            vehicle_id: this.formData.vehicle,
            ...( this.canAppendThisTypeOfHour('simples') ?  {simples: this.parseHours(this.formData.simpleHours.hours, this.formData.simpleHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('night') ?  {night: this.parseHours(this.formData.nightHours.hours, this.formData.nightHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('overnight') ?  {overnight: this.parseHours(this.formData.overnightHours.hours, this.formData.overnightHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('extra') ?  {extra: this.parseHours(this.formData.extraHours.hours, this.formData.extraHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('simple_presence_time') ?  {simple_presence_time: this.parseHours(this.formData.simplePresentHours.hours, this.formData.simplePresentHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('simple_special') ?  {simple_special: this.parseHours(this.formData.simpleSpecialHours.hours, this.formData.simpleSpecialHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('extra_rest') ?  {extra_rest: this.parseHours(this.formData.extraRestHours.hours, this.formData.extraRestHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('simple_rest') ?  {simple_rest: this.parseHours(this.formData.simpleRestHours.hours, this.formData.simpleRestHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('extra_special') ?  {extra_special: this.parseHours(this.formData.extraSpecialHours.hours, this.formData.extraSpecialHours.minutes)} : {}) ,
            ...( this.canAppendThisTypeOfHour('vehicle_stopped_time') ?  {vehicle_stopped_time: this.parseHours(this.formData.stoppedTimeHours.hours, this.formData.stoppedTimeHours.minutes)} : {}) ,
            closed_segments: this.periodItems.map((period) => {
                return {
                    vehicle_id: period.vehicle.id,
                    datetime_from: this.getDateTime(period.datetime_from, period.hourStart),
                    datetime_to: this.getDateTime(period.datetime_to, period.hourEnd)
                };
            }),
        };

        return data
    }

    canAppendThisTypeOfHour(type){
        return existItemInList(this.hourTypes, 'type', type)
    }

    get FormattedData(){
        return this.getFormattedData()
    }

    get getDataForPrecalculate() {
        this.periodsWhenPrecalculate = this.periodItems
        return {
            driver_id: this.formData.driver.ci,
            company_id: this.$_getSelectedCompanyById as number,
            closed_segments: this.periodItems.map((period) => {
                return {
                    vehicle_id: period.vehicle.id,
                    datetime_from: this.getDateTime(period.datetime_from, period.hourStart),
                    datetime_to: this.getDateTime(period.datetime_to, period.hourEnd)
                };
            })
        }
    }

    get canPrecalculate() {
        if( this.periodItems == undefined || !this.periodItems.length) {
            this.periodsAreValid = false
            return
        } 
        this.periodsAreValid = false
        this.periodItems.map(period => { 
            if(period.saved) { 
                this.periodsAreValid = true 
            } else { 
                this.periodsAreValid = false 
            }})
        return Boolean(
            this.formData.driver.ci &&
                this.periodsAreValid
        );
    }

    get PrecalculateMsgs(){
        if(!this.formData.driver.ci && !this.periodsAreValid) {
            return 'Debe seleccionar un chofer y un periodo valido'
        } else if(!this.formData.driver.ci){
            return 'Debe seleccionar un chofer'
        } else if(!this.periodsAreValid) {
            return 'Debe seleccionar un periodo valido'
        } else {
            return ''
        }
    } 

    getTransformedDateTime(date) {
        return this.getDateTime(this.getOnlyDateDay(date), this.getOnlyHourAndMinutes(date));
    }

    getOnlyDateDay(date) {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    getOnlyHourAndMinutes(date) {
        const hours = ('0' + date.getHours()).slice(-2)
        const minutes = ('0' + date.getMinutes()).slice(-2)
        
        return `${hours}:${minutes}`;
    }

    getFullTimeToDisplay(hours, minutes) {
        return hours + 'h ' + minutes + 'm';
    }

    get getFormatedHour() {
        return `${this.formData.simpleHours.hours}H${this.formData.simpleHours.minutes}M`;
    }

    get getColorUnnasignedTime() {
        if (!this.assignedHoursAreEqualToTotalOfHours) {
            return 'red';
        } else {
            return 'green';
        }
    }

    isValidDate(d) {
        return d instanceof Date && !isNaN(<number>(<unknown>d));
    }

    get getValidPeriods() {
        if(this.$_getVehiclesFromSelectedCompanySorted.length != 0) {
            return this.periodItems.filter((period) => {
                const startDate = this.getPeriodStartDate(period);
                const endDate = this.getPeriodEndDate(period);
                return this.isValidDate(startDate) && this.isValidDate(endDate);
            });
        }
    }

    getPeriodEndDate(period) {
        if(this.isValidDate(period.datetime_to)){
            period.datetime_to = period.datetime_to.replace(/-/g, "/");
        }
        
        return new Date(period.datetime_to + ' ' + period.hourEnd);
    }

    getPeriodStartDate(period) {
        if(this.isValidDate(period.datetime_from)){
            period.datetime_from = period.datetime_from.replace(/-/g, "/");
        }
        return new Date(period.datetime_from + ' ' + period.hourStart);
    }

    get getJourneyStartDate() {
        if (this.getValidPeriods == undefined || this.getValidPeriods.length == 0) return null;
        return this.getValidPeriods.map(this.getPeriodStartDate).reduce(this.getMinimumDate);
    }

    get getJourneyEndDate() {
        if (this.getValidPeriods == undefined || this.getValidPeriods.length == 0) return null;
        return this.getValidPeriods.map(this.getPeriodEndDate).reduce(this.getMamixumDate);
    }

    get getPeriodErrorMsg(){
        return this.periodErrorMsg
    }

    get shouldShowSaveButton() {
        this.periodErrorMsg = '';

        if(isNullOrEmpty(this.editedItem.vehicle)){
            this.periodErrorMsg = 'No seleccionó el vehiculo';
            return false
        }

        if(isNullOrEmpty(this.editedItem.datetime_from)){
            this.periodErrorMsg = 'No seleccionó Fecha de Inicio';
            return false
        }

        if(isNullOrEmpty(this.editedItem.hourStart)){
            this.periodErrorMsg = 'No seleccionó Hora de Inicio';
            return false
        }

        if(isNullOrEmpty(this.editedItem.datetime_to)){
            this.periodErrorMsg = 'No seleccionó Fecha de Fin';
            return false
        }

        if(isNullOrEmpty(this.editedItem.hourEnd)){
            this.periodErrorMsg = 'No seleccionó Hora de Fin';
            return false
        }

        let startDate = `${this.editedItem.datetime_from}T${this.editedItem.hourStart}`;
        let endDate = `${this.editedItem.datetime_to}T${this.editedItem.hourEnd}`
        const finPosteriorInicio = moment(endDate, 'YYYY-M-DDTHH:mm').isAfter(moment(startDate, 'YYYY-M-DDTHH:mm'));

        if (!finPosteriorInicio) {
            this.periodErrorMsg = 'La fecha de Fin debe ser posterior a la inicial';
            return false;
        }
        const finNoFuturo = moment(endDate, 'YYYY-M-DDTHH:mm').isSameOrBefore(moment());

        if(!finNoFuturo){
            this.periodErrorMsg = 'No puede crear períodos a futuro';
            return false
        }

        this.periodErrorMsg = '';
        return true
        
    }
    get shouldShowCancelButton() {
        return this.isEditingItem && this.shouldShowSaveButton;
    }
    get shouldShowCloseButton() {
        return !this.shouldShowCancelButton;
    }
    get isEditingItem() {
        return this.editedItem.edit
    }

    get canAddNewItem() {
        return this.isEditingItem || this.editedIndex !== -1;
    }

    getMamixumDate(a: Date, b: Date) {
        if (a > b) return a;
        return b;
    }

    getMinimumDate(a: Date, b: Date) {
        if (a < b) return a;
        return b;
    }

    getParsedDate(value){
        return getDateAsMoment(value)
    }

    get getHoursJourneyTime(): number {
        if (!this.getJourneyStartDate || !this.getJourneyEndDate) return 0;
        const duration = getDurationBetweenDates(this.getParsedDate(this.getJourneyStartDate), this.getParsedDate(this.getJourneyEndDate))
        // duration in hours
        return parseInt(duration.asHours().toString());
    }
    get getMinutesJourneyTime(): number {
        if (!this.getJourneyStartDate || !this.getJourneyEndDate) return 0;
        const duration = getDurationBetweenDates(this.getParsedDate(this.getJourneyStartDate), this.getParsedDate(this.getJourneyEndDate))
        // duration in minutes
        return parseInt(duration.asMinutes().toString()) % 60;
    }

    get getTotalJourneyTime() {
        const hours = this.getHoursJourneyTime;
        const minutes = this.getMinutesJourneyTime;
        return hours + 'h ' + minutes + 'm';
    }

    get getAssignedTime() {
        return this.changeDisplayedFormat(this.formatAssignedTime(this.getTotalTimeAssigned));
    }

    get getTotalTimeAssigned() {
        return this.totalHoursAssigned + ':' + this.totalMinutesAssigned;
    }

    get getHoursOptions() {
         for (let hour = 0; hour < 24; hour++) {
            this.hoursSelector.push(this.getHourOption(hour, 0));
            this.hoursSelector.push(this.getHourOption(hour, 15));
            this.hoursSelector.push(this.getHourOption(hour, 30));
            this.hoursSelector.push(this.getHourOption(hour, 45));
            this.hoursSelector.push(this.getHourOption(hour, 55));
        }
        return this.hoursSelector;
    }

    getHourOption(hour, min){
        return getDateFormattedAsMoment({ hour, minute: min }, dateTypes.hoursAndMinutesFormat)
    }

    get getUnnasignedHours() {
        if (this.periodItems.length === 0) {
            return `0h 0m`;
        }

        const journeyTime = moment
            .duration(this.getHoursJourneyTime, 'hours')
            .add(moment.duration(this.getMinutesJourneyTime, 'minutes'));
        const assignableTime = moment
            .duration(this.totalHoursAssigned, 'hours')
            .add(moment.duration(this.totalMinutesAssigned, 'minutes'));

        const totalJourneyMinutes = journeyTime.asMinutes();
        const totalAssignedMinutes = assignableTime.asMinutes();

        let unnasignedMinutes = totalJourneyMinutes - totalAssignedMinutes;

        const sign = unnasignedMinutes < 0 ? -1 : 1;
        unnasignedMinutes = Math.abs(unnasignedMinutes);

        const hours = Math.floor(unnasignedMinutes / 60) * sign;
        const minutes = unnasignedMinutes % 60; 


        return `${hours}h ${minutes}m`;

    }

    changeDisplayedFormat(time) {
        let hours = parseInt(time.split(':')[0]);
        let minutes = parseInt(time.split(':')[1]);

        return hours + 'h ' + minutes + 'm';
    }

    formatAssignedTime(time) {
        let hours = parseInt(time.split(':')[0]);
        let minutes = parseInt(time.split(':')[1]);
        if (minutes > 59) {
            let hoursInMin = hours * 60;
            let totalTimeinMin = hoursInMin + minutes;

            hours = Math.floor(totalTimeinMin / 60);
            minutes = Math.floor(totalTimeinMin % 60);
        }

        return hours + ':' + minutes;
    }

    formatTime(time) {
        return getDateFormattedAsMoment(time, dateTypes.hoursAndMinutesFormatMinus, dateTypes.hoursAndMinutesFormat)
    }

    get assignedHoursAreEqualToTotalOfHours() {
        let journeyTime = this.getTotalJourneyTime;
        let assignedTime = this.getAssignedTime;
        
        if (journeyTime == assignedTime) {
            this.assignedHoursAreValid = true;
            return true;
        }

        this.assignedHoursAreValid = false;
        return false
    }

  

    //Methods
    minutesValidation(val) {
        if (val > 60 || val < 0) {
            return 'Número inválido';
        } else {
            return true;
        }
    }
    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }
    getDateTime(date, hour) {
        if (date.indexOf('T') !== -1) {
            return date;
        } else {
            return date + 'T' + hour + ':00';
        }
    }

    parseHours(hours, minutes) {
        //remove leading zeros from hours and minutes
        let finalHours: any = hours !== null ? parseInt(Number(hours).toString()) : null;
        let finalMinutes: any = minutes !== null ? parseInt(Number(minutes).toString()) : null;

        if (finalHours < 10) {
            if (finalHours == null) {
                finalHours = '00';
            } else {
                finalHours = '0' + finalHours;
            }
        }

        if (finalMinutes < 10) {
            if (finalMinutes == null) {
                finalMinutes = '00';
            } else {
                finalMinutes = '0' + finalMinutes;
            }
        }
        // console.log ("return:", finalHours + 'H' + finalMinutes + 'M' + '00S');
        return finalHours + 'H' + finalMinutes + 'M' + '00S';
    }
    submitForm() {
        JourneysService.postCreateJourney(this.FormattedData)
            .then((response) => {
                let res = response;
                this.$emit('journey-created', {
                    status: true,
                    msg: res.message,
                    id: res.journey_id
                });
                this.$_successPatchRecipients('Jornada creada con exito');
            })
            .catch((error) => {
                 this.createJourneyError();
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo crear la jornada'
                });
            });
    }

    resetPreviousHours(){
        this.replaceDataBecauseOfPrecalculateJourney(
            {
                "hours_worked": {
                    "simples": "00H00M00S", 
                    "simple_presence_time": "00H00M00S",
                    "extra": "00H00M00S", 
                    "overnight": "00H00M00S", 
                    "night": "00H00M00S", 
                    "simple_rest": "00H00M00S", 
                    "simple_special": "00H00M00S",
                    "extra_rest": "00H00M00S", 
                    "extra_special": "00H00M00S"
                }
        })
    }

    precalculateJourney() {
        
        this.pendingRequest = true;
        JourneysService.precalculateJourney(this.getDataForPrecalculate)
            .then((response) => {
                this.resetPreviousHours();
                this.precalculated = true
                this.stops = response.stops
                this.replaceDataBecauseOfPrecalculateJourney(response)
                this.pendingRequest = false;
                this.$_successPatchRecipients('Jornada precalculada con exito')
            })
            .catch((error) => {
                this.precalculated = false
                this.pendingRequest = false;
                this.$_showHistoricalError(error.response.data.message);
            });
    }

    replaceDataBecauseOfPrecalculateJourney(res){
        // TIEMPO SIMPLE
        this.formData.simpleHours.hours = this.getHours(res.hours_worked.simples);
        this.formData.simpleHours.minutes = this.getMinutes(res.hours_worked.simples)

        // TIEMPO EXTRA
        this.formData.extraHours.hours = this.getHours(res.hours_worked.extra);
        this.formData.extraHours.minutes = this.getMinutes(res.hours_worked.extra)

        // TIEMPO SIMPLE PRESENCIA
        this.formData.simplePresentHours.hours = this.getHours(res.hours_worked.simple_presence_time);
        this.formData.simplePresentHours.minutes = this.getMinutes(res.hours_worked.simple_presence_time);

        // TIEMPO PERNOCTE
        this.formData.overnightHours.hours = this.getHours(res.hours_worked.overnight);
        this.formData.overnightHours.minutes = this.getMinutes(res.hours_worked.overnight);
        if(res.hours_worked && res.hours_worked['night']){
            // TIEMPO NOCTURNO
            this.formData.nightHours.hours = this.getHours(res.hours_worked.night);
            this.formData.nightHours.minutes = this.getMinutes(res.hours_worked.night);
        }
        
        if(res.hours_worked && res.hours_worked['simple_special']){
            //Tiempo simple special
            this.formData.simpleSpecialHours.hours = this.getHours(res.hours_worked.simple_special);
            this.formData.simpleSpecialHours.minutes = this.getMinutes(res.hours_worked.simple_special);
        }

        if(res.hours_worked && res.hours_worked['extra_rest']){
            //Tiempo extra rest
            this.formData.extraRestHours.hours = this.getHours(res.hours_worked.extra_rest);
            this.formData.extraRestHours.minutes = this.getMinutes(res.hours_worked.extra_rest);
        }

        if(res.hours_worked && res.hours_worked['simple_rest']){
             //Tiempo Simple rest
            this.formData.simpleRestHours.hours = this.getHours(res.hours_worked.simple_rest);
            this.formData.simpleRestHours.minutes = this.getMinutes(res.hours_worked.simple_rest);
        }

         if(res.hours_worked && res.hours_worked['extra_special']){
             //Tiempo extra rest
            this.formData.extraSpecialHours.hours = this.getHours(res.hours_worked.extra_special);
            this.formData.extraSpecialHours.minutes = this.getMinutes(res.hours_worked.extra_special);
         }

         if(res.hours_worked && res.hours_worked['vehicle_stopped_time']){
             //Tiempo stopped time
            this.formData.stoppedTimeHours.hours = this.getHours(res.hours_worked.vehicle_stopped_time);
            this.formData.stoppedTimeHours.minutes = this.getMinutes(res.hours_worked.vehicle_stopped_time);
         }
    }

    getHours(time){
        return Number(time.substr(0, 2));
    }

    getMinutes(time){
        return Number(time.substr(3, 2));
    }
    checkIfDateIsValid(){
        return dateIsSameOrAfterSecond(this.formData.dateStart, this.formData.dateEnd, true)
    }

    checkIfDateEndIsAfterInitial() {
        this.removeErrorById(1);
        if (
            this.formData.dateEnd &&
            this.formData.dateEnd !== 0 &&
            this.formData.dateStart &&
            this.formData.dateStart !== 0
        ) {
            if (!this.checkIfDateIsValid()) {
                this.errors.push({
                    id: 1,
                    text: 'La fecha de fin debe ser posterior o igual a la inicial'
                });
                this.dateIsValid = false;
            } else {
                this.dateIsValid = true;
            }
        }
    }

    removeErrorById(id) {
        this.errors = this.errors.filter((item) => item.id !== id);
    }

    @Watch('formData.simpleHours.hours')
    @Watch('formData.simpleHours.minutes')
    @Watch('formData.nightHours.hours')
    @Watch('formData.nightHours.minutes')
    @Watch('formData.extraHours.hours')
    @Watch('formData.extraHours.minutes')
    @Watch('formData.simplePresentHours.hours')
    @Watch('formData.simplePresentHours.minutes')
    @Watch('formData.overnightHours.hours')
    @Watch('formData.overnightHours.minutes')
    @Watch('formData.vehicle')
    @Watch('formData.driver')
    @Watch('formData.dateStart')
    @Watch('formData.dateEnd')
    @Watch('assignedHoursAreValid')
    @Watch('formData.simpleSpecialHours.hours')
    @Watch('formData.simpleSpecialHours.minutes')
    @Watch('formData.stoppedTimeHours.hours')
    @Watch('formData.stoppedTimeHours.minutes')
    @Watch('formData.extraSpecialHours.hours')
    @Watch('formData.extraSpecialHours.minutes')
    @Watch('formData.extraRestHours.hours')
    @Watch('formData.extraRestHours.minutes')
    @Watch('formData.simpleRestHours.hours')
    @Watch('formData.simpleRestHours.minutes')
    observableFields() {
        this.checkIfFormIsValid();
    }

    @Watch('formIsValid')
    watchFormIsValid(value) {
        if (value) {
            this.$emit('enable-submit', true);
        } else {
            this.$emit('enable-submit', false);
        }
    }

    @Watch('periodItems')
    checkIfFormIsValid() {
        let formIsCorrect = false;
        if (
            this.periodItems &&
            this.periodItems.length != 0 &&
            this.periodItems[0].saved &&
            this.formData['driver'].ci &&
            this.assignedHoursAreValid &&
            !this.canAddNewItem
        ) {
            formIsCorrect = true
        }
        this.formIsValid = formIsCorrect
    }

    getTotalHoursAssigned() {
        let totalAssignedHours =
            this.formatValueToNumber(this.formData.simpleHours.hours) +
            this.formatValueToNumber(this.formData.extraHours.hours) +
            this.formatValueToNumber(this.formData.simplePresentHours.hours) +
            this.formatValueToNumber(this.formData.overnightHours.hours) +
            this.formatValueToNumber(this.formData.simpleSpecialHours.hours) +
            this.formatValueToNumber(this.formData.extraSpecialHours.hours) +
            this.formatValueToNumber(this.formData.extraRestHours.hours)+
            this.formatValueToNumber(this.formData.stoppedTimeHours.hours) +
            this.formatValueToNumber(this.formData.simpleRestHours.hours)

        if(this.journeyCalcType !== 3){
            totalAssignedHours += this.formatValueToNumber(this.formData.nightHours.hours);
        }

        return totalAssignedHours;
    }

    getTotalMinutesAssigned() {
        let totalMinutesAssigned =
            this.formatValueToNumber(this.formData.simpleHours.minutes) +
            this.formatValueToNumber(this.formData.extraHours.minutes) +
            this.formatValueToNumber(this.formData.simplePresentHours.minutes) +
            this.formatValueToNumber(this.formData.overnightHours.minutes) +
            this.formatValueToNumber(this.formData.simpleSpecialHours.minutes) +
            this.formatValueToNumber(this.formData.extraSpecialHours.minutes) +
            this.formatValueToNumber(this.formData.extraRestHours.minutes) +
            this.formatValueToNumber(this.formData.stoppedTimeHours.minutes) +
            this.formatValueToNumber(this.formData.simpleRestHours.minutes);

            if(this.journeyCalcType !== 3){
                totalMinutesAssigned += this.formatValueToNumber(this.formData.nightHours.minutes);
            }

        return totalMinutesAssigned;
    }

    formatDate(date) {
        if (date && date !== null) {
            return getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars, dateTypes.dateYearFormatReverse)
        } 
        return null;
    }

    formatDateHoursMinutes(date) {
        if (date && date !== null) {
            return getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars, dateTypes.dateYearFormatReverse) +
            ' a las ' + getDateFormattedAsMoment(date, dateTypes.hoursAndMinutesFormat)
        }
        return null;
    }

    formatValueToNumber(value) {
        if (!value) {
            return 0;
        } else {
            return parseInt(value);
        }
    }

    getMinutesFromHoursAndMinutes(hours, minutes) {
        let timeInMinutes;
        if (!hours) {
            hours = 0;
        }

        if (!minutes) {
            minutes = 0;
        }

        timeInMinutes = parseInt(hours) * 60 + parseInt(minutes);
        return timeInMinutes;
    }

    selectDriver(driver) {
        this.$set(this.formData, 'driver', driver.ci);
    }
    selectVehicle(vehicle) {
        this.$set(this.formData, 'vehicle', vehicle.id);
    }
    selectStartHour(selectedHour) {
        let validateTime = this.validateTime(selectedHour);
        if (validateTime.isValid()) {
            this.editedItem.hourStart = selectedHour;
        } else {
            this.editedItem.hourStart = '';
        }
    }
    selectEndHour(selectedHour) {
        let validateTime = this.validateTime(selectedHour);
        if (validateTime.isValid()) {
            this.editedItem.hourEnd = selectedHour;
        } else {
            this.editedItem.hourEnd = '';
        }
    }

    validateTime(time) {
        return timeIsValid(time)
    }
    datePickerValidation(val) {
        if (val == null || val == undefined) {
            return '';
        } else if (!this.checkDate(val)) {
            return '';
        } else if (val.length > 10) {
            return '';
        } else {
            return true;
        }
    }

    @Emit()
    createJourneyError(){}

    checkDate(date) {
        if (date.length !== 10) {
            return false;
        } else {
            let years = getDiffToNow(date, diffOptions.years);
            if (years > 100 || years < 0) {
                return false;
            } else {
                return true;
            }
        }
    }

    getTodayDateLessVal(val) {
        let d = new Date();
        let year = d.getFullYear();
        let month = d.getMonth();
        let day = d.getDate();
        let c = new Date(year - val, month, day).toISOString().substr(0, 10);
        return c;
    }

    getFormattedDate(date){
        return date ? getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars) : null
    }

    saveStartDate(date) {
        let formattedDate = this.getFormattedDate(date);
        let menuElement = this.$refs.menuStart as HTMLFormElement;
        menuElement.save(formattedDate);
    }

    saveEndDate(date) {
        let formattedDate = this.getFormattedDate(date);
        let menuElement = this.$refs.menuEnd as HTMLFormElement;
        menuElement.save(formattedDate);
    }

    resetForm() {
        let formElement = this.$refs.formAbm as HTMLFormElement;
        this.$nextTick(() => {
            if (formElement) {
                formElement.reset();
                formElement.resetValidation();
            }
        });
        this.totalJourneyHours = 0;
        this.totalJourneyTime = 0;
        this.totalTimeAssigned = 0;
        this.totalTimeAssignedFormatted = 0;
        this.totalTimeAssignedFormatted = 0;
        this.assignedHoursAreValid = false;
        this.unnasignedHours = 0;
        this.formData = this.defaultFormData;
        this.errors = [];
    }

    @Watch('formData.simpleHours.minutes')
    watchValue(val, old) {
        if (val > 59) {
            this.formData.simpleHours.minutes = 0;
        }
    }

    @Watch('formData.nightHours.minutes')
    watchNightMinutes(val, old) {
        if (val > 59) {
            this.formData.nightHours.minutes = 0;
        }
    }

    @Watch('formData.extraHours.minutes')
    watchExtraMinutes(val, old) {
        if (val > 59) {
            this.formData.extraHours.minutes = 0;
        }
    }

    @Watch('formData.simplePresentHours.minutes')
    watchSimplePresentMinutes(val, old) {
        if (val > 59) {
            this.formData.simplePresentHours.minutes = 0;
        }
    }

    @Watch('formData.overnightHours.minutes')
    watchOvernightMinutes(val, old) {
        if (val > 59) {
            this.formData.overnightHours.minutes = 0;
        }
    }

    get driversFromCompany() {
        const options = this.$_getDriversFromSelectedCompany;
        if (options instanceof Array) return options;
        return [];
    }
}
